import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue';
import function1 from '../views/function.vue';
import commission from '../views/commission.vue';
import buy from '../views/buy.vue';
import preview from '../views/preview.vue';
Vue.use(VueRouter)

const routes = [
   {
      path: '/',
      name: 'home',
      component: home,
      meta: {
         title: '首页',
         index: 0,
      }
   }, {
      path: '/function',
      name: 'function',
      component: function1,
      meta: {
         title: '功能介绍',
         index: 1,
      }
   }, {
      path: '/commission',
      name: 'commission',
      component: commission,
      meta: {
         title: '思维导图',
         index: 2,
      }
   }, {
      path: '/buy',
      name: 'buy',
      component: buy,
      meta: {
         title: '购买授权',
         index: 3,
      }
   }, {
      path: '/preview',
      name: 'preview',
      component: preview,
      meta: {
         title: '系统演示',
         index: 4,
      }
   }
]

const router = new VueRouter({
   mode: 'hash',
   base: process.env.BASE_URL,
   routes
})



export default router
